import { ViewBasic } from '@quatrecentquatre/manage-me';
import { bindAll } from 'underscore';

// Vitesse de défilement du texte, en pixels par seconde
const SPEED = 40;

export class PromotionHeader extends ViewBasic {
    constructor(options) {
        super(options);
    }

    initialize() {
        bindAll(this, ['update']);
        this.text = this.el.querySelector('.promotion-header__text');
        this.update();
        this.addEvents();
    }

    addEvents() {
        window.addEventListener('resize', this.update);
    }

    removeEvents() {
        window.removeEventListener('resize', this.update);
    }

    // Fait défiler le texte seulement s'il est trop long pour sa boîte
    update() {
        this.el.classList.remove('is-scrolling');

        if (this.el.scrollWidth > this.el.clientWidth) {
            this.el.classList.add('is-scrolling');
            this.el.style.setProperty('--promotion-header-duration', `${this.text.offsetWidth / SPEED}s`);
        }
    }
}

Me.views['PromotionHeader'] = PromotionHeader;
